import React, { useEffect, useState } from "react";
import "./Contact.css";
import NavbarComponent from "../../components/navbar/NavbarComponent";
import Footer from "../../components/footer/Footer";
import { toast } from "react-toastify";
import { API } from "../../constants/Api";
import Meta from "../../components/Meta";

function Contact() {
  const [isTab, setIsTab] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsTab(window.innerWidth <= 990);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function formValidations() {
    if (name.trim().length < 1) {
      toast.error("Name is required");
      return false;
    }

    if (email.trim().length < 1) {
      toast.error("Email is required");
      return false;
    }

    if (message.trim().length < 1) {
      toast.error("Message is required");
      return false;
    }

    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validate = await formValidations();
    if(validate){
      const data = {
        name,
        email,
        phone,
        message
      }

      const toastLoading = toast.loading("sending message...")
      setLoading(true)

      try{
        const response = await fetch(`${API}/contact/contact-us`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "Application/json"
          }
        })

        const json = await response.json()

        if(response.ok){

          setLoading(false)
          toast.dismiss(toastLoading)
          toast.success(json.message)


        }else{
          toast.error(json.message)
        }
        

      }catch(error){
        toast.error(error.message)
      }finally{
        setLoading(false)
        toast.dismiss(toastLoading)
      }
    }
  };
  return (
    <>
      <Meta 
        title="Contact Deal Direct Homes | Customer Support and Inquiries" 
        description="Find contact information for Deal Direct Homes customer support, media inquiries, and other departments."
      />
      <div className="advertiser-details">
        <NavbarComponent />
        <div
          className="container-fluid px-0"
          style={{ paddingBottom: "120px" }}
        >
          <div className="row px-0 mx-0 advertiser-details-page-section-1">
            <div className="col-md-6 px-0 d-flex align-items-center">
              <div className="container-fluid px-0">
                <div className="row px-0 mx-0">
                  <div className="container-fluid">
                    <h2 className="agent-register-heading">Reach Out To Us</h2>
                    <p className="before-begin-span">
                      Got any worries? No sweat, we’re here for you!
                    </p>
                  </div>
                </div>
                <div className="row px-0 mx-0">
                  <div className="container-fluid advertiser-details-page-card-3">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="container-fluid">
                          <div className="row">
                            {/* <div className="col-12 advertiser-details-page-card-3-profile">
                              <div className="advertiser-details-page-card-3-image">
                             <div className="advertiser-details-page-card-3-image-media-1"></div>
                              </div>
                              <div className="advertiser-details-page-card-3-details">
                                <h3
                                  className="advertiser-details-page-card-3-details-name my-0"
                                  style={{ textTransform: "capitalize" }}
                                >
                                  (262) 695-3395
                                </h3>
                              </div>
                            </div> */}
                            <div className="col-12 advertiser-details-page-card-3-profile">
                              <div className="advertiser-details-page-card-3-image">
                                <div className="advertiser-details-page-card-3-image-media-2"></div>
                              </div>
                              <div className="advertiser-details-page-card-3-details">
                                <h3 className="advertiser-details-page-card-3-details-name my-0">
                                  support@dealdirecthomes.com
                                </h3>
                              </div>
                            </div>
                            <div className="col-12 advertiser-details-page-card-3-profile">
                              <div className="advertiser-details-page-card-3-image">
                                <div className="advertiser-details-page-card-3-image-media-3"></div>
                              </div>
                              <div className="advertiser-details-page-card-3-details">
                                <h3
                                  className="advertiser-details-page-card-3-details-name my-0"
                                  style={{ textTransform: "capitalize" }}
                                >
                                  California, United States
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`col-md-6 ${isTab ? "pt-4" : ""}`}>
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6502595.146296284!2d-119.306607!3d37.2691675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2s!4v1741688036096!5m2!1sen!2s"
                          width="100%"
                          height={450}
                          style={{ border: 0, borderRadius: "20px" }}
                          allowFullScreen
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 px-0 d-none d-lg-block justify-centent-center align-items-center">
              <div className="container-fluid d-flex justify-content-center">
                <img
                  src="/img/contact-us.png"
                  className="img-fluid contact-us-image mx-auto"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="container-fluid px-0"
          style={{ paddingBottom: "120px" }}
        >
          <div className="row px-0 mx-0 advertiser-details-page-section-2 d-flex justify-content-center px-0">
            <div className="col-md-12 px-0">
              <div className="container-fluid contact-us-page-card-3 py-5">
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 d-flex justify-content-center">
                    <h2 className="contact-us-h1">
                      How About We Get In Touch With You?
                    </h2>
                  </div>
                </div>
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 d-flex justify-content-center">
                    <form className="agent-register-form">
                      <input
                        type="text"
                        className="form-control send-message-input-field"
                        id="exampleInputEmail1"
                        placeholder="Full Name"
                        aria-describedby="emailHelp"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />

                      <input
                        type="text"
                        className="form-control send-message-input-field"
                        id="exampleInputPassword1"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <div className="send-message-phone-number-group">
                        <button className="send-message-phone-code">+1</button>
                        <input
                          type="number"
                          className="form-control send-message-phone-field"
                          id="exampleInputPassword1"
                          placeholder="Phone Number"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </div>

                      <textarea
                        type="text"
                        className="form-control send-message-text-area"
                        id="exampleInputPassword1"
                        placeholder="Your Message"
                        rows={5}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                      {loading ? (
                        <button
                          className="btn agent-register-button"
                        
                        >
                          Sending message...
                        </button>
                      ) : (
                        <button
                          className="btn agent-register-button"
                          onClick={handleSubmit}
                        >
                          Send Message
                        </button>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Contact;
